import { React, PropTypes, reduxConnect, styled } from '../lib/imports';
import { Image, SectionTitle, Spacing, Text } from '../components';
import { useCdnUrl } from './../app/context/config';

const StreaksContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionBg};
`;

const StreaksImageContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionBg};
`;

export const StreaksDisclaimer = styled(Text)`
  flex: 1;
  padding: 20px 0;
  text-align: center;
  font-size: 14px;
  margin-top: -55px;
  a {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const Streaks = ({ title, blurb, streakSrc, disclaimerTerms }) => {
  const cdnUrl = useCdnUrl();
  return (
    <StreaksContainer>
      <Spacing>
        <SectionTitle text={title} shadow size='deca' />
      </Spacing>
      <Spacing sizeLeft='peta' sizeRight='peta' sizeTop='tera' sizeBottom='tera'>
        <Text centered size='tera'>
          {blurb}
        </Text>
      </Spacing>
      <Spacing sizeLeft='mega' sizeRight='mega' paddingBottom='tera'>
        <StreaksImageContainer>
          <Image src={`${cdnUrl}${streakSrc}`} />
          <StreaksDisclaimer>{disclaimerTerms}</StreaksDisclaimer>
        </StreaksImageContainer>
      </Spacing>
    </StreaksContainer>
  );
};

Streaks.propTypes = {
  title: PropTypes.string,
  blurb: PropTypes.string,
  disclaimer: PropTypes.string,
  streakSrc: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { strings } = state;

  const allStrings = {
    title: strings['titles/section/streaks/text'],
    blurb: strings['heatstreak/gameinfo/blurb'],
    disclaimerTerms: strings['heatstreak/gameinfo/disclaimerTerms'],
  };

  return {
    ...allStrings,
    streakSrc: strings['heatstreak/gameinfo/image'],
  };
};

export default reduxConnect(mapStateToProps)(Streaks);
